
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/instagram-tracker",
      function () {
        return require("private-next-pages/instagram-tracker/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/instagram-tracker"])
      });
    }
  